import { render } from "./index.vue?vue&type=template&id=3cedcd64&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=3cedcd64&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3cedcd64"

export default script